import React from "react";
import "./style.css";
import { Helmet } from "react-helmet";
// import Trending from "components/TrendingNow/Trending";
import PresentationCard from "components/PresentationCard/PresentationCard";
import { Timeline } from 'react-twitter-widgets';
//import { TwitterTimelineEmbed,TwitterFollowButton} from 'react-twitter-embed';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "components/Footer/Footer";
import TitleSection from "components/TitleBar/TitleSection";
import { getKey, current_unix_stamp, timeStampDiff, unixTimeStamp,unixDateConversion,timeDiff, } from "utils/Helper";
import CategoryModal from "pages/LoginPage/RegisterForm/CategoryModal/CategoryModal";
import { user_Status, user_API } from "Api/Api";
import Help from "../../Assets/Qicon.png";
import Container from "react-bootstrap/Container";
import Carousel from "react-bootstrap/Carousel";
import Button from "../../components/Button/Button";
import axios from 'axios';
import { events_list_api,search_Presentation_API,events_search_list_api, HeaderConfig, managed_contents, managed_contents_PechaKucha_Inc, myHeaders_Autorized, user_entity_uuid, user_access_level } from "Api/Api";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { withRouter } from "react-router-dom";
import { local_routes } from 'utils/Routes';
import { NavLink } from "react-router-dom";
import FeaturedVideosButton from "components/Modals/FeaturedVideosButton";

import YouTube from 'react-youtube';

import UserContext from 'store/UserContext';

import home from 'Assets/home.svg';
import heroImg0 from 'Assets/hero-banner-adjusted/ipk2020_better.JPG';
import heroImg1 from 'Assets/hero-banner-adjusted/imge-1.jpg';
import heroImg2 from 'Assets/hero-banner-adjusted/imge-2.jpg';
import heroImg3 from 'Assets/hero-banner-adjusted/imge-3.jpg';
import heroImg4 from 'Assets/hero-banner-adjusted/imge-4.jpg';
import heroImg5 from 'Assets/hero-banner-adjusted/imge-5.jpg';
import heroImg6 from 'Assets/hero-banner-adjusted/imge-6.jpg';
import heroImg7 from 'Assets/hero-banner-adjusted/imge-7.jpg';
import heroImg8 from 'Assets/hero-banner-adjusted/imge-8.jpg';
import heroImg9 from 'Assets/hero-banner-adjusted/imge-9.jpg';
import heroImg10 from 'Assets/hero-banner-adjusted/imge-10.jpg';
import rightArrow from 'Assets/arrow-right-circle.svg';
import pechakuchaNight from 'Assets/logo-city.png';
let modal_stat_key, modalStatus;
let randomColors = ['#00FDC3', '#6EAAFF', '#AE7BFF', '#FF626F', '#FFAB9C', "#00C294", "#FFF2A2", "#AE7BFF", "#FF626F", "#FFD266", "#6EAAFF", "#00FDC3"];
let carouselImage=[
  heroImg0,
  heroImg1,
  heroImg2,
  heroImg3,
  heroImg4,
  heroImg5,
  heroImg6,
  heroImg7,
  heroImg8,
  heroImg9,
  heroImg10
];

class HomePage extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      youtube_display_flag: false,
      youtube_embed_video_id: null,
      youtube_title: '',
      homepage_banner_images_array: [],
      modalStatus: 0,
      noUserPresentations: [],
      featuredPk: [],
      featuredPkInc: [],
      noUserFeaturedCatInc: [],
      loading: true,
      userFavCatPresentation: [],
      managedContentsHtml: null,
      managedContentsHtmlSectionOne: {},
      managedContentsHtmlSectionTwo: {},
      managedContentsHtmlSectionThree: {},
      carousalArr: [],
      cityStaticArr: [],
      topCategoryBasedPresentations: [],
      userCity:null,
      nearbyEventData:null,
    };
  }

  componentDidMount = async function () {
    this.ModalValidator();
    // API Calls starts here

    // JBB always do these
    this.commonPromiseAPICalls();
    this.noUserPromiseAPICalls();

    // JBB 4/24/2020 - during qurantine, always use default event
    this.defEvent();

    // if logged in user, get favorite category info
    if (user_Status === 1) {
      try {
        // User data API
        /*
        //let user_location_data = await axios.get(`${user_API}/${user_entity_uuid}/locations.audience?filter[resident_integer][gte]=1`, myHeaders_Autorized);
        let user_location_data = await axios.get(`${user_API}/${user_entity_uuid}/locations.audience?filter_obj=${encodeURIComponent('{"resident_integer":{"gte":1}}')}`, myHeaders_Autorized);
        let user_location_res=user_location_data.data;
        if (user_location_res.length > 0) {
          this.setState({userCity:user_location_res[0].friendly_url})
          if (user_location_res[0].friendly_url && user_location_res[0].friendly_url !== null && user_location_res[0].friendly_url !== undefined) {
            // API if user has selected city
            //let nearby_event_api = await axios.get(`${events_search_list_api}?search_start_time=${current_unix_stamp}&start_time_order=ASC&locations_text=${user_location_res[0].entity_name}&limit=1`, myHeaders_Autorized);
            let nearby_event_api = await axios.get(`${events_search_list_api}?search_start_time=${current_unix_stamp}&start_time_order=ASC&limit=1`, myHeaders_Autorized);
            let nearby_event_api_res = nearby_event_api.data.search_query_results;
            // const { nearbyEventData } = this.state;
            console.log("YO0",nearby_event_api_res);
            if(nearby_event_api_res.length === 0) {
              this.defEvent()
            } else {
              let resData = nearby_event_api_res[0].entity_info;
              let start_time = unixDateConversion(resData.start_time);
              let timeDiffer = timeDiff(start_time)
              let location_data = await axios.get(`${events_list_api}/${resData.entity_uuid}/locations?limit=1`, myHeaders_Autorized);
              if (nearby_event_api_res && nearby_event_api_res.length > 0) {
                let locData = location_data.data[0];
                
                let locEvntType = locData.xref_data && locData.xref_data.event_type === "night" ? true : false;
                let eventInfo = {
                  image_url: locData.city_skyline_wide_image_url !== undefined ? locData.city_skyline_wide_image_url : locData.city_skyline_image_url,
                  location_name: locData.entity_name,
                  event_type: locEvntType,
                  loc_friendly_url:locData.friendly_url,
                  event_entity_name: resData.entity_name,
                  event_friendly_url: resData.friendly_url,
                  //event_startsIn: ` ${timeDiffer.hoursDiff} hours, ${timeDiffer.minsDiff} minutes`,
                  event_startsIn: ' '+this.get_starts_in_string(timeDiffer),
                }
                
                this.setState({ nearbyEventData: eventInfo })
              }
            }
            // API if user has selected city end
          } else{
            this.defEvent();
          }
        } else {
          this.defEvent();
        }
        */
      
        let presentateTempArr = []
        //let fav_cats_response = await axios.get(`${user_API}/${user_entity_uuid}/categories.audience?sort[created_time]=asc&limit=3`, myHeaders_Autorized);
        let fav_cats_response = await axios.get(`${user_API}/${user_entity_uuid}/categories.audience?sort_obj=${encodeURIComponent('{"created_time":"asc"}')}&limit=3`, myHeaders_Autorized);
        let cat_info_promises = [];
        let DifftimeStamp = timeStampDiff(1000);
        let parsedUnixTime = unixTimeStamp(DifftimeStamp);
        for (let fav_cat of fav_cats_response.data) {
          let params = {
            presentation_format: '20x20',
            get_presenter: true,
            categories_uuid: fav_cat.entity_uuid,
            categories_text: fav_cat.entity_name,
            search_start_time: parsedUnixTime,
            search_end_time: current_unix_stamp,
            sort_by: 'view_count',
            sort_order: 'DESC',
            limit: 1
          }
          //cat_info_promises.push(axios.get(`${search_Presentation_API}?presentation_format=20x20&get_presenter=true&categories_uuid=${fav_cat.entity_uuid}&categories_text=${fav_cat.entity_name}&search_start_time=${parsedUnixTime}&search_end_time=${current_unix_stamp}&sort_by=view_count&sort_order=DESC&limit=1`, HeaderConfig));
          cat_info_promises.push(axios.get(`${search_Presentation_API}`, { params, ...HeaderConfig }));
        }
        let fav_cats_info_responses = await Promise.all(cat_info_promises);
        for (let fav_cat_info_response of fav_cats_info_responses) {
          presentateTempArr.push(fav_cat_info_response.data.search_query_results[0].entity_info);
        }
        this.setState({ userFavCatPresentation: presentateTempArr });
      } catch (err) {
        this.setState({ loader: false })
      }
    } else {
      //this.defEvent();
    }
  }

  get_starts_in_string = function (timeDiffer) {
    let starts_in_array = [];
    let starts_in_string = '';
    let full_starts_in = <span></span>;
    
    if (timeDiffer.daysDiff >= 0) {
      if (timeDiffer.daysDiff) {
        if (timeDiffer.daysDiff === 1) {
          starts_in_array.push(timeDiffer.daysDiff+' day');
        } else if (timeDiffer.daysDiff >= 1) {
          starts_in_array.push(timeDiffer.daysDiff+' days');
        } else {
          // starts in zero days! no need to put in zero days
        }
      }
      if (timeDiffer.hoursDiff) {
        if (timeDiffer.hoursDiff === 1) {
          starts_in_array.push(timeDiffer.hoursDiff+' hour');
        } else if (timeDiffer.hoursDiff >= 1) {
          starts_in_array.push(timeDiffer.hoursDiff+' hours');
        } else {
          // starts in zero hours! no need to put in zero days
        }
      }
      if (timeDiffer.minsDiff === 1) {
        starts_in_array.push(timeDiffer.minsDiff+' minute');
      } else if (timeDiffer.minsDiff >= 1) {
        starts_in_array.push(timeDiffer.minsDiff+' minutes');
      } else {
        // starts in zero minutes! no need to put in zero minutes
      }
      starts_in_string = starts_in_array.join(', ');
      full_starts_in = <span><b>Starts in</b>&nbsp;{starts_in_string}</span>;
    } else {
      // event already started
      if (timeDiffer.daysDiff < -1) {
        starts_in_array.push(Math.abs(timeDiffer.daysDiff)+' days');
      } else {
        // started less than one day ago - no need to put in days
      }
      if (timeDiffer.hoursDiff < 23) {
        // started more than an hour ago
        starts_in_array.push((24 - timeDiffer.hoursDiff)+' hours');
      } else {
        // started less than an hour ago - no need to put in hours
      }
      if (timeDiffer.minsDiff < 59) {
        // started more than a minute ago
        starts_in_array.push((60 - timeDiffer.minsDiff)+' minutes');
      } else {
        // started less than a minute ago - no need to put in minutes
      }
      starts_in_string = starts_in_array.join(', ');
      full_starts_in = <span><b>Started</b>&nbsp;{starts_in_string} ago</span>;
    }
     
    //return starts_in_string;
    return full_starts_in;
  }

  defEvent = async function () {
    // API if no selected city
    //  get next event thst starts from anywhere from 3 hours ago
    let nearby_event_api = await axios.get(`${events_search_list_api}?search_start_time=${current_unix_stamp - 10800}&locations_text=all&start_time_order=ASC&limit=1`);
    //let nearby_event_api = await axios.get(`${events_search_list_api}?search_start_time=${current_unix_stamp}&start_time_order=ASC&limit=1`);
    let nearby_event_api_res = nearby_event_api.data.search_query_results;
    if (nearby_event_api_res && nearby_event_api_res.length > 0) {
      let resData = nearby_event_api_res[0].entity_info;
      //console.log("HMM1",resData);
      let start_time = unixDateConversion(resData.start_time);
      let timeDiffer = timeDiff(start_time);
      let source_response = [];
      let source_type;
      if (resData.locations_uuid || resData.locations_text) {
        source_response = await axios.get(`${events_list_api}/${resData.entity_uuid}/locations?limit=1`);
        source_type = 'locations';
      } else if (resData.channels_uuid || resData.channels_text) {
        source_response = await axios.get(`${events_list_api}/${resData.entity_uuid}/channels?limit=1`);
        source_type = 'events';
      }
      
      if (source_response.data && source_response.data[0]) {
        let source_data = source_response.data[0];
        let source_link;
        if (source_type === 'locations') {
          source_link = `${local_routes.cities}/${source_data.friendly_url}`;
        } else {
          source_link = `${local_routes.channels}/${source_data.friendly_url}`;
        }
        //console.log("YO2",locData);
        let event_type = source_data.xref_data && source_data.xref_data.event_type ? source_data.xref_data.event_type : 'event';
        let eventInfo = {
          image_url: source_data.city_skyline_wide_image_url || source_data.city_skyline_image_url || source_data.logo_image_url,
          location_name: source_data.entity_name,
          loc_friendly_url:source_link,
          event_type: event_type,
          event_entity_name: resData.entity_name,
          event_friendly_url: resData.friendly_url,
          //event_startsIn: ` ${timeDiffer.hoursDiff} hours, ${timeDiffer.minsDiff} minutes`,
          event_startsIn: this.get_starts_in_string(timeDiffer),
        }
        this.setState({ nearbyEventData: eventInfo })
      }
    }
    // API if no selected city end
  }

  noUserPromiseAPICalls = () => {
    //let DifftimeStamp = timeStampDiff(100);
    let DifftimeStamp = timeStampDiff(30);
    let parsedUnixTime = unixTimeStamp(DifftimeStamp);
    // User API Calls starts here
    Promise.all([
      axios.get(`${search_Presentation_API}?presentation_format=20x20&get_presenter=true&sort_by=view_count&search_start_time=${parsedUnixTime}&search_end_time=${current_unix_stamp}&limit=${3}`, HeaderConfig),
    ])
      .then(([noUserPresentationRes]) => {
        // No user presentations for Trending Pks
        if (noUserPresentationRes && noUserPresentationRes.data.search_query_results.length !== 0) {
          let noUserPresentationArr = []
          noUserPresentationRes.data.search_query_results.forEach(function (item) {
            noUserPresentationArr.push(item.entity_info)
          })
          this.setState({ noUserPresentations: noUserPresentationArr, })
        }

      });
    // User API Calls Ends here

    // API Calls ends here
  }

  commonPromiseAPICalls = () => {
    // Not logged API Calls starts here
    let params = {
        do_recursive: true,
        filter_obj: {
          featured_time: {
            gte: 1
          }
        },
        sort_obj: {
          featured_time: 'desc'
        },
        limit: 18
      };
    Promise.all([
      //axios.get(`${managed_contents_PechaKucha_Inc}/categories?sort[featured_time]=desc&limit=12`, HeaderConfig),
      axios.get(`${managed_contents_PechaKucha_Inc}/categories?sort_obj=${encodeURIComponent('{"featured_time":"desc"}')}&limit=12`, HeaderConfig),
      //axios.get(`${managed_contents_PechaKucha_Inc}/presentations?sort[featured_time]=desc&limit=3`, HeaderConfig),
      axios.get(`${managed_contents_PechaKucha_Inc}/presentations`, {params, ...HeaderConfig}),
      axios.get(`${managed_contents}/homepage`, HeaderConfig),
      axios.get(`${managed_contents}/homepage_banner_images`, HeaderConfig)
    ])
      .then(([noUsermanagedContentsCatIncRes, managedContentsPkIncRes, managed_contentsOtherDataRes, homepage_banner_images_response]) => {
        let homepage_banner_images_array = [];
        if (homepage_banner_images_response.data && homepage_banner_images_response.data.image_urls) {
          for (let image_url of homepage_banner_images_response.data.image_urls) {
            let url = image_url;
            let array = url.split("/");
            image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/1920x480/${array[5]}`;
            homepage_banner_images_array.push(image_url);
          }
          //this.setState({ homepage_banner_images_array });
        } else {
          // default
          //this.setState({ homepage_banner_images_array: carouselImage });
          homepage_banner_images_array = carouselImage;
        }

        // noUserFeaturedCatInc Browse by category page
        //let DifftimeStamp = timeStampDiff(1000);
        let DifftimeStamp = timeStampDiff(60);
        let parsedUnixTime = unixTimeStamp(DifftimeStamp);
        if (noUsermanagedContentsCatIncRes) {
          let noUsermanagedContentsCatArr = []; let catBasedTopTempPresen = [];
          noUsermanagedContentsCatIncRes.data.forEach((item, index) => {
            noUsermanagedContentsCatArr.push(item)
            if (index < 3) {
              let category_name = item.entity_name; let friendly_url = item.friendly_url;
              let params = {
                presentation_format: '20x20',
                get_presenter: true,
                categories_uuid: item.entity_uuid,
                categories_text: item.entity_name,
                search_start_time: parsedUnixTime,
                search_end_time: current_unix_stamp,
                sort_by: 'view_count',
                sort_order: 'DESC',
                limit: 3
              }
              //axios.get(`${search_Presentation_API}?presentation_format=20x20&get_presenter=true&categories_uuid=${item.entity_uuid}&categories_text=${item.entity_name}&search_start_time=${parsedUnixTime}&search_end_time=${current_unix_stamp}&sort_by=view_count&sort_order=DESC&limit=3`, HeaderConfig)
              axios.get(`${search_Presentation_API}`, { params, ...HeaderConfig })
                .then(response => {
                  // topCategoryBasedPresentations
                  catBasedTopTempPresen.push({ category_Name: `${category_name}`, friendly_url: `${friendly_url}`, category_Presentation_Arr: response.data.search_query_results })
                  this.setState({
                    topCategoryBasedPresentations: catBasedTopTempPresen,
                  })
                })
                .catch(() => {
                  this.setState({ loader: false })
                });
            }
          })
          this.setState({ noUserFeaturedCatInc: noUsermanagedContentsCatArr })
        }
        // Featured Pks
        if (managedContentsPkIncRes.data.length !== 0) {
          let managedContentsPkArr = [];
          managedContentsPkIncRes.data.forEach((item) => {
            managedContentsPkArr.push(item)
          })
          this.setState({ featuredPkInc: managedContentsPkArr })
        }

        // Other section data like banner, Pechakucha is all about etc,...
        if (managed_contentsOtherDataRes) {
          let youtube_display_flag = false;
          let youtube_embed_video_id = null;
          let youtube_title = '';
          if (managed_contentsOtherDataRes.data.content_sections.youtube_embed_section_01) {
            if (managed_contentsOtherDataRes.data.content_sections.youtube_embed_section_01.display_flag && managed_contentsOtherDataRes.data.content_sections.youtube_embed_section_01.link_url) {
              youtube_display_flag = true;
              youtube_embed_video_id = managed_contentsOtherDataRes.data.content_sections.youtube_embed_section_01.link_url;
              youtube_title = managed_contentsOtherDataRes.data.content_sections.youtube_embed_section_01.title || '';
            }
          }
          
          let carousalTempArr = [];let carImageProcessedTempArr=[]
          carousalTempArr.push({ data: managed_contentsOtherDataRes.data.content_sections.rotating_section_01 }, { data: managed_contentsOtherDataRes.data.content_sections.rotating_section_02 }, { data: managed_contentsOtherDataRes.data.content_sections.rotating_section_03 })
          carousalTempArr.forEach((item,index)=>{
            let url = item.data.image_url;
            let array = url.split("/");
            carImageProcessedTempArr[index]={
              html_content:item.data.html_content,
              image_url:`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_noborder_360x311/${array[5]}`,
              title:item.data.title,
              link_url: item.data.link_url
            }
          })

          let cityStaticTempArr = [];let cityStaticImageProcessedTempArr=[]
          cityStaticTempArr.push({ data: managed_contentsOtherDataRes.data.content_sections.city_section_01 }, { data: managed_contentsOtherDataRes.data.content_sections.city_section_02 }, { data: managed_contentsOtherDataRes.data.content_sections.city_section_03 }, { data: managed_contentsOtherDataRes.data.content_sections.city_section_04 })
          cityStaticTempArr.forEach((item,index)=>{
            let url = item.data.image_url;
            let array = url.split("/");
            cityStaticImageProcessedTempArr[index]={
              html_content:item.data.html_content,
              image_url:`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/263x280/${array[5]}`,
              title:item.data.title,
              link_url: item.data.link_url
            }
          })

          this.setState({
            youtube_display_flag,
            youtube_embed_video_id,
            youtube_title,
            homepage_banner_images_array,
            managedContentsHtml: managed_contentsOtherDataRes.data,
            managedContentsHtmlSectionOne: managed_contentsOtherDataRes.data.content_sections.section_01,
            managedContentsHtmlSectionTwo: managed_contentsOtherDataRes.data.content_sections.section_02,
            carousalArr: carImageProcessedTempArr,
            cityStaticArr: cityStaticImageProcessedTempArr,
            managedContentsHtmlSectionThree: managed_contentsOtherDataRes.data.content_sections.section_03,
            loading: false
          })
        }

      });
    // Not logged API Calls Ends here

    // API Calls ends here
  }

  ModalValidator() {
    modal_stat_key = getKey("First_Time_Status");
    modalStatus = JSON.parse(modal_stat_key);
  }
  
  /*
  // JBB - deprecated?
  // Page Navigation Starts Here
  CreatePk = () => {
    if (user_Status === 1) {
      this.props.history.push("/pkcreation");
    }
    else {
      window.location.href = `${origin}/login`;
    }
  }
  // Page Navigation Ends Here
  */

  render() {
    // const guestHomeHead1 = carouselImage.map(item=>{
    //   backgroundImage: `url(${item.image_url})`
    // })
    const youtube_opts = {
      height: '585',
      width: '960',
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
      },
    };
    
    
    const {nearbyEventData,noUserPresentations, carousalArr, cityStaticArr, topCategoryBasedPresentations, managedContentsHtmlSectionOne, managedContentsHtmlSectionTwo, managedContentsHtmlSectionThree, userFavCatPresentation, noUserFeaturedCatInc, featuredPkInc } = this.state;
    const guestHomeHead = nearbyEventData !== null ?    
    { backgroundImage: `url(${nearbyEventData.image_url})`, }
    :
    { backgroundImage: `url(${managedContentsHtmlSectionOne.image_url})`, };
    const spaceStyles = { marginLeft: 0, marginRight: 0 };

    let trending_presentations = userFavCatPresentation.concat(noUserPresentations);
    if (trending_presentations.length > 3) {
      trending_presentations.length = 3;
    }
    
    if (this.state.loading === true) {
      return (
        <ActivityIndicator theme="spinner" />
      )
    }
    else {
      return (

        <div className="main-section home-section">
          <Helmet defer={false}>
            <title>Pecha Kucha 20x20: Discover Pecha Kucha presentations, stories, ideas, examples, and videos that will inspire</title>
          </Helmet>
          {/* This will show category and Personalizing modal to first time user for first time only */}
          {user_Status === 1 ?
          <div>
            <CategoryModal setModalShow={modalStatus === 1 ? true : false} />
            </div>
            : null}

          {/* Banner section starts */}
          {user_Status === 1 ?
            (
              null
            )
            : (
              managedContentsHtmlSectionOne ?
              <div style={{position: 'relative'}}>
                  <div className="container">
              {/* <section className="heroImageContent" style={{position: 'absolute', top: 50, zIndex: 999}}>
              <Row style={spaceStyles}>
              <Col sm={12} md={12} lg={8}>
                <section className="guesthome-head">
                    <div className="row">
                      <Col sm={12} md={12} lg={12}>
                        <div className="guest-btn">
                          <h1>{managedContentsHtmlSectionOne.title}</h1>
                          <div className="guesthome-content">
                            <p dangerouslySetInnerHTML={{ __html: managedContentsHtmlSectionOne.html_content }}></p>
                          </div>
                          <a href="/login" className="btn-start-color">
                          <Button theme="btn-global btn-hover btn-green btn-fit">
                            Join Community</Button></a>
                        </div>
                      </Col>
                    </div>
                </section>
                </Col>
              </Row>
              </section> */}
                  </div>
                <section className="heroContainer">
                  <Carousel fade={true} pause={'hover'} controls={false} indicators={false} interval={5000}>
                    {
                      this.state.homepage_banner_images_array.map((img,i) => {
                        return (
                          <Carousel.Item key={i} className="fade-carousel" style={{height: '100%'}}>
                            <div className="home-carousel-img heroImageContent pk-guesthome-head" style={{backgroundImage: `url(${img})`}}>
                            <div className="container">
                            <Row style={spaceStyles}>
                              <Col sm={12} md={12} lg={8}>
                                <section className="guesthome-head">
                                    <div className="row">
                                      <Col sm={12} md={12} lg={12}>
                                        <div className="guest-btn">
                                          <h1>{managedContentsHtmlSectionOne.title}</h1>
                                          <div className="guesthome-content">
                                            <p dangerouslySetInnerHTML={{ __html: managedContentsHtmlSectionOne.html_content }}></p>
                                          </div>
                                          <a href="/register" className="btn-start-color">
                                          <Button theme="btn-global btn-hover btn-green btn-fit">
                                            Join Community</Button></a>
                                        </div>
                                      </Col>
                                    </div>
                                </section>
                                </Col>
                              </Row>
                              </div>
                            </div>
                            {/* <img src={img} alt={`hero-img-${i+1}`} style={{width: '100%',height:'100%'}}/> */}
                           
                            {/* <span className="heroImgeMask" /> */}
                          </Carousel.Item>
                        )
                      })
                    }
                  </Carousel>
                </section>
              </div>
              : null
            )}
          {/* Banner section Ends */}

          {/* about-pechakucha starts */}

          {user_Status === 1 ? null : (
            <section className="about-guest">
              <div className="container">
                <div className="about-pechakucha">
                  <Row>
                    <Col lg={2} md={3} sm={12}>
                      <div className="home-imgcenter">
                        <img src={Help} alt="" />
                      </div>
                    </Col>
                    <Col lg={10} md={9} sm={12}>
                      <div className="pechaKuchaPresenters">
                        <h1>{managedContentsHtmlSectionTwo.title}</h1>
                        <p dangerouslySetInnerHTML={{ __html: managedContentsHtmlSectionTwo.html_content }} className="readMore"></p>
                      </div>
                    </Col>
                  </Row>
                  <div>
                    <Row>
                      <Col lg={3} md={3} sm={12}>
                        <div className="green-box eventcategory-box">
                          <h1>140+</h1>
                          <h4>Countries</h4>
                        </div>
                      </Col>
                      <Col lg={3} md={3} sm={12}>
                        <div className="blue-box eventcategory-box">
                          <h1>1200+</h1>
                          <h4>Cities</h4>
                        </div>
                      </Col>
                      <Col lg={3} md={3} sm={12}>
                        <div className="pink-box eventcategory-box">
                          <h1>10K+</h1>
                          <h4>Events</h4>
                        </div>
                      </Col>
                      <Col lg={3} md={3} sm={12}>
                        <div className="red-box eventcategory-box">
                          <h1>130K+</h1>
                          <h4>Presenters</h4>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </section>
          )}
          {/* about-pechakucha ends */}

          <section id="trending-events">
          
          { (this.state.youtube_display_flag && this.state.youtube_embed_video_id) &&
          <Container>
            <Row>
              <Col>
                <h2 className="global-main-heading">{this.state.youtube_title}</h2>
                <YouTube
                  videoId={this.state.youtube_embed_video_id}
                  opts={youtube_opts}
                  containerClassName={"youtubeContainer"}
                />
              </Col>
            </Row>
          </Container>
          }
          
            {
              (!this.state.youtube_display_flag && nearbyEventData !== null) && 
              <div className="container">
                <div className="global-pechakucha-twitter">
              <h2 className="global-main-heading">{`PechaKucha Spotlight: ${nearbyEventData.location_name}`}</h2>
              <Row>
                <Col lg={6} sm={12} md={12}>
                  
                  <div className={`pechakucha-night-events pechakucha-night-events-${this.context.theme}`}>
                    <NavLink to={`${local_routes.events}/${nearbyEventData.event_friendly_url}`}>
                      <div style={{
                        ...guestHomeHead
                      }} className="global-pechakucha">
                        <div className="startTimer">{nearbyEventData.event_startsIn}</div>
                        <div className="pechakucha-global-data">
                          <div>
                            {
                              nearbyEventData.event_type === 'night' &&
                              <img src={pechakuchaNight} alt="night-logo"/>
                            }
                            <h1 className="global-heading">{nearbyEventData.location_name}</h1>
                          </div>
                          <img src={rightArrow} alt="right-img"/>
                        </div>
                      </div>
                    </NavLink>
                    <div className="see-all-events"><NavLink to={nearbyEventData.loc_friendly_url}>{`See PechaKucha ${nearbyEventData.location_name} featured presentations`}</NavLink></div>
                  </div>
                </Col>
                <Col lg={6} sm={12} md={12}>
                    <Timeline
                            dataSource={{
                              sourceType: 'profile',
                              screenName: 'PechaKucha'
                            }}
                            options={{
                              chrome: 'noscrollbar noborders noheader nofooter',
                              height: '309',
                              theme: this.context.theme
                            }}
                    />
                </Col>
              </Row>
            </div>
            </div>
            }


            
            {featuredPkInc.length > 0 &&
              <div className="marBot20">
                <Container>
                  {/* Featured Pks starts */}
                          {/* LCK BUTTON FOR FEATURED VIDEOS MODAL */}
                          <Row className="justify-content-bewteen">
                              <Col>
                                <TitleSection
                                    title="Featured PechaKucha Presentations"
                                    seeAll={featuredPkInc.length > 0 ? "false" : "false"}
                                    Title_link='/pklist'
                                />
                              </Col>
                              <Col md={3} className="mb-2">
                                {(user_access_level==='admin')?(<FeaturedVideosButton homePageAPI={()=>this.commonPromiseAPICalls()}/>):(null)}
                              </Col>
                          </Row>
                  <div>
                    <Row>
                      {featuredPkInc.map(item => (
                        <Col lg={4} sm={12} md={6} key={item.entity_uuid}>
                          <PresentationCard
                            key={item.entity_uuid}
                            presentation_info={item}
                            skip_relative_time={true}
                          />
                          {/*
                          <Trending
                            key={item.entity_uuid}
                            Trending_now_title={item.entity_name}
                            Trending_now_text={item.description}
                            Trending_img={item.image_url}
                            Trending_link={`${local_routes.presentations}/${item.friendly_url}`}
                          />
                          */}
                        </Col>
                      ))}
                    </Row>
                  </div>
                  {/* Featured Pks Ends */}
                </Container>
              </div>
            }


            {trending_presentations.length >= 3 &&
              <div className="marbot10">
                <Container>
                  {/* Trending Pks starts */}
                      <TitleSection
                        title="Trending PechaKucha Presentations"
                        seeAll={userFavCatPresentation.length > 0 ? 'false' : 'false'}
                        Title_link="/pklist"
                      />
                    <Row>
                      {trending_presentations.map(item => (
                        <Col key={item.entity_uuid} lg={4} sm={12} md={6}>
                          <PresentationCard
                            key={item.entity_uuid}
                            presentation_info={item}
                            skip_relative_time={true}
                          />
                          {/*
                          <Trending
                            key={item.entity_uuid}
                            Trending_now_title={item.entity_name}
                            Trending_now_text={item.description}
                            Trending_img={item.image_url}
                            Trending_link={`${local_routes.presentations}/${item.friendly_url}`}
                          />
                          */}
                        </Col>
                      ))}
                    </Row>
                  {/* Trending Pks Ends */}
                </Container>
              </div>
            }
          </section>

          {/* Browse by category section  starts*/}
          {noUserFeaturedCatInc.length >0 &&
          <section id="browse" className="marbot10">
            <div className="container">
              <div className="marbot10">
                <TitleSection
                  title="Browse by Category"
                  Title_link={local_routes.categories}
                />
              </div>
              <Row>
                {
                  noUserFeaturedCatInc.map((item) =>
                    <Col  key={item.friendly_url} lg={3} md={3} sm={12} className="pr-2">
                      <NavLink to={`${local_routes.categories}/${item.friendly_url}`}>
                      <div className="hobbies-box category-box"
                        style={{ backgroundColor: randomColors[Math.floor(Math.random() * randomColors.length)] }}
                      >
                        <h4>{item.entity_name}</h4>
                      </div>
                      </NavLink>
                    </Col>
                  )
                }
              </Row>
            </div>
          </section>
          }
          {/* Browse by category ends */}

          {/* Top hobbies and craft pk's , Top Art & Design Pks starts*/}
          {topCategoryBasedPresentations.length > 0 &&
          <section id="trending-eve">
            <div className="marBot20">
              <Container>
                {/* topCategoryBasedPresentations */}
                  {
                    topCategoryBasedPresentations.map((item,index) => {
                      return (
                        <div key={index} style={{ display: item.category_Presentation_Arr.length === 0 ? 'none' : null }}>
                          <div className="case-studies">
                          {item.category_Presentation_Arr ?
                            <div id="home">

                                <TitleSection
                                  title={`Top ${item.category_Name} PechaKucha Presentations`}
                                  seeAll={item.category_Presentation_Arr.length > 0 ? "true" : "false"}
                                  Title_link={`${local_routes.categories}/${item.friendly_url}`}
                                />

                              <Row>
                                {item.category_Presentation_Arr.map((data) => {
                                  return (
                                    <Col  key={data.entity_info.entity_uuid} lg={4} sm={12} md={6}>
                                      
                                      <PresentationCard
                                        key={data.entity_info.entity_uuid}
                                        presentation_info={data.entity_info}
                                        skip_relative_time={true}
                                      />
                                      
                                      {/*
                                      <Trending
                                        key={data.entity_info.entity_uuid}
                                        Trending_now_title={data.entity_info.entity_name}
                                        Trending_now_text={data.entity_info.description}
                                        Trending_img={data.entity_info.image_url}
                                        Trending_link={`${local_routes.presentations}/${data.entity_info.friendly_url}`}
                                      />
                                      */}
                                      
                                    </Col>
                                  );
                                })}
                              </Row>
                            </div>
                            : null
                          }
                          </div>
                        </div>
                      )
                    })
                  }
              </Container>
            </div>
          </section>
          }
          {/* Top hobbies and craft pk's , Top Art & Design Pks Ends*/}

          {/* Carousal and PK About data section starts */}
          {carousalArr.length > 0 && managedContentsHtmlSectionThree !== undefined ?
          <section id="carousel">
            <div className="container">
              <div className="marbot10">
                <Row>
                  <Col lg={4} md={12} sm={12}>
                    {/* carousalArr */}
                    <div className="h-100">
                      <Carousel>
                        {
                          carousalArr.map((item,index) =>

                            <Carousel.Item  key={index}>
                              <NavLink to={item.link_url}>
                              <div className="overlay"></div>
                              <img
                                className="d-block w-100 h-100"
                                src={item.image_url}
                                alt="First slide"
                              />
                              <Carousel.Caption>
                                <h3>{item.title}</h3>
                                <p dangerouslySetInnerHTML={{ __html: item.html_content }}></p>
                              </Carousel.Caption>
                              </NavLink>
                            </Carousel.Item>

                          )
                        }
                      </Carousel>
                    </div>
                  </Col>
                  <Col lg={8} md={12} sm={12}>
                    <div className="pechakucha-presenting">
                      <h3>{managedContentsHtmlSectionThree.title}</h3>
                      <p dangerouslySetInnerHTML={{ __html: managedContentsHtmlSectionThree.html_content }}></p>
                      <div className="create-pk">

                      {
                        user_Status === 1 ?
                        <NavLink to={local_routes.pkcreation}>
                        <Button
                          theme="btn-global btn-green"
                        >
                          Create a PK
                        </Button>
                        </NavLink>
                        :
                        <NavLink to={local_routes.pkcreatehome}>
                        <Button
                          theme="btn-global btn-green"
                        >
                          Create a PK
                        </Button>
                        </NavLink>
                      }
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </section>
          : null }
          {/* Carousal and PK About data section starts */}


          {/* Find an event in your city section starts here */}
          {cityStaticArr.length > 0 ?
          <section id="find-event">
            <div className="container">
              <div className="events-city">
                <TitleSection
                  title="Find an Event in Your City"
                  seeAll={cityStaticArr.length > 0 ? "true" : "false"}
                  Title_link={local_routes.events}
                />

                <div className="cities">
                  <Row>
                    {cityStaticArr.map((item,index) => (
                      <Col key={index} lg={3} md={6} sm={12} className="pt-20">
                        <NavLink to={item.link_url}>
                        <Button theme={`img-btn img-btn-${this.context.theme}`}>
                          <div className="blog">
                            <div className="blog-img-home">
                              <img
                                src={item.image_url}
                                className="img-fluid rounded"
                                alt="city Img"
                              />
                            </div>
                            <div className="city-content">
                              <h4>{item.title}</h4>
                              <p>{item.html_content}</p>
                            </div>
                          </div>
                        </Button>
                        </NavLink>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </div>
          </section>
          : null }
          {/* Find an event in your section ends here*/}

          <Footer
          homeImg={home}/>
        </div>
      );
    }
  }
}

export default withRouter(HomePage);
